<nb-card class="sort-card">
    <nb-card-header>
            {{ title }}
            
            <div class="message" *ngIf="message">{{ message }}</div>
    </nb-card-header>
  
    <nb-card-body class="sort-card-body">
      <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
        <div class="pos-rel listheader">
          <span>Position</span>
          <span class="pos-abs lft100">{{ displayField | titlecase }}</span>
        </div>
        <div class="example-box pos-rel" *ngFor="let item of items; index as i" cdkDrag>
          <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
          <span>{{ i+1 }}</span>
          <span class="pos-abs lft100">{{ item[displayField] }}</span>
        </div>
      </div>
    </nb-card-body>
  
    <nb-card-footer>
      <div class="d-foot-action">
         
          <button nbButton  status="danger" (click)="cancel()">Cancel</button>
          <button nbButton status="primary" (click)="save()">Save</button>
      </div>
    </nb-card-footer>
  </nb-card>